import React from 'react';
import {
    FormControl,
    InputLabel
} from 'material-ui';
import Select from 'react-select';

export const SelectMultiple = (props) => {
    return (
        <FormControl style={{width: '100%'}}>
            <InputLabel htmlFor={'field-dd-' + props.id}>{props.label}</InputLabel>
            <Select
                id={'field-dd-' + props.id}
                name={props.name}
                placeholder={props.label ? props.label : 'Type here to search...'}
                multi
                closeOnSelect={props.closeOnSelect ? props.closeOnSelect : false}
                value={props.selectedItems}
                onChange={selectedItems => {
                    props.onItemsChange(selectedItems);
                }}
                options={props.items}
                labelKey={props.labelKey}
                valueKey={props.valueKey}
            />
        </FormControl>
    )
}


// WEBPACK FOOTER //
// ./src/components/fields/field_multi_select.js